import {
  Avatar,
  Badge,
  Box,
  Button,
  IconButton,
  Menu,
  Skeleton,
  Stack,
  Tooltip,
} from "@mui/material";
import { ROUTES } from "constants/routes";
import React, { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { AvatarProps } from "utils/image.util";
import { authLinks, headerLinks } from "./LinkData";
import ListYourEquipmentBtn from "./ListYourEquipementBtn";
import MenuOptions from "./MenuOptions";
import NotificationOpt from "./notification";

const NavLinks = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { authReducer, cartReducer, userReducer }: any = useAppSelector(
    (state) => state
  );
  const { userProfile } = userReducer;
  const {
    isLoggedIn,
    isSubmitting,
    isLoadingAuth,
    loginState = { displayName: "", pic: "", email: "" },
  } = authReducer;
  const { displayName, pic, email } = loginState;
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const dispatch = useAppDispatch();

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: { xs: "none", md: "flex" },
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      {isSubmitting || isLoadingAuth ? (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Skeleton variant="text" sx={{ fontSize: "2rem" }} width="100px" />
          <Skeleton variant="text" sx={{ fontSize: "2rem" }} width="100px" />
          <Skeleton variant="text" sx={{ fontSize: "2rem" }} width="100px" />
          <Skeleton variant="text" sx={{ fontSize: "2rem" }} width="100px" />
          <Box
            sx={{
              backgroundColor: "header.background.light",
              display: "flex",
              padding: "0 14px",
              marginLeft: 1.5,
              gap: "10px",
              alignItems: "center",
              height: "65px",
              pr: 4,
            }}
          >
            <Skeleton variant="text" sx={{ fontSize: "2rem" }} width="100px" />
            <Skeleton variant="text" sx={{ fontSize: "2rem" }} width="100px" />
            <Skeleton variant="circular" width={40} height={40} />
          </Box>
        </Stack>
      ) : (
        <Fragment>
          {headerLinks.map(
            (link: any) =>
              !link?.hideFromHeader && (
                <Button
                  key={link?.label}
                  onClick={() => {
                    !link?.action && navigate(link?.path);
                    link?.action && link?.action();
                  }}
                  sx={{
                    my: 2,
                    color:
                      link?.path == pathname ? "white" : "header.links.main",
                    backgroundColor:
                      link?.path == pathname ? "primary.main" : "transparent",
                    display: "block",
                    fontSize: "15px",
                    fontWeight: 500,
                    "&:hover": {
                      color: "primary.main",
                    },
                  }}
                >
                  {link?.label}
                </Button>
              )
          )}

          {/* ------------- End Of Header Link Buttons ------------------- */}
          {/* ------------- Start Of Auth Buttons ------------------- */}
          <Box
            sx={{
              backgroundColor: "header.background.light",
              display: "flex",
              padding: "0 8px",
              marginLeft: 1.5,
              gap: "10px",
              alignItems: "center",
            }}
          >
            {!isLoggedIn &&
              authLinks.map((link: any) => (
                <Button
                  key={link?.label}
                  onClick={() => navigate(link?.path)}
                  sx={{
                    my: 2,
                    color:
                      link?.path == pathname ? "white" : "header.links.main",
                    backgroundColor:
                      link?.path == pathname ? "primary.main" : "transparent",
                    display: "block",
                    fontSize: "15px",
                    fontWeight: 500,
                    "&:hover": {
                      color: "primary.main",
                    },
                  }}
                >
                  {link?.label}
                </Button>
              ))}

            <ListYourEquipmentBtn isLoggedIn={isLoggedIn} />

            {/* {isLoggedIn && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="15px"
            mx="15px"
          >
            <IconButton onClick={() => navigate(ROUTES.CART)}>
              <Badge
                badgeContent={cartReducer?.items?.length ?? 0}
                color="primary"
              >
                <img
                  src="/assets/img/icons/cart_add.svg"
                  height="30px"
                  width="28px"
                  alt=""
                />
              </Badge>
            </IconButton>
            <IconButton onClick={() => navigate(ROUTES.CART)}>
              <Badge
                badgeContent={cartReducer?.items?.length ?? 0}
                color="primary"
              >
                <img
                  src={require("assets/img/png/message_ic 2.png")}
                  height="30px"
                  width="28px"
                  alt=""
                />
              </Badge>
            </IconButton>
            <IconButton onClick={() => navigate(ROUTES.CART)}>
              <Badge badgeContent={3} color="error">
                <img
                  src={require("assets/img/png/notifi_ic.png")}
                  height="30px"
                  width="28px"
                  alt=""
                />
              </Badge>
            </IconButton>
          </Box>
        )} */}

            {isLoggedIn && (
              <IconButton onClick={() => navigate(ROUTES.CART)}>
                <Badge
                  badgeContent={
                    cartReducer?.items?.length > 100
                      ? `99+`
                      : cartReducer?.items?.length
                  }
                  color="error"
                >
                  <img
                    src="/assets/img/icons/cart_add.svg"
                    height="20"
                    width="20"
                    alt=""
                  />
                </Badge>
              </IconButton>
            )}

            {isLoggedIn && (
              <IconButton onClick={() => navigate("/messages")}>
                <Badge
                  badgeContent={
                    authReducer?.unReadMessages?.length > 100
                      ? "99+"
                      : authReducer?.unReadMessages?.length
                  }
                  color="error"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.98 14.79C17.98 15.05 17.97 15.3 17.94 15.54C17.71 18.24 16.12 19.58 13.19 19.58H12.79C12.54 19.58 12.3 19.7 12.15 19.9L10.95 21.5C10.42 22.21 9.56 22.21 9.03 21.5L7.82999 19.9C7.69999 19.73 7.41 19.58 7.19 19.58H6.79001C3.60001 19.58 2 18.79 2 14.79V10.79C2 7.86001 3.35001 6.27001 6.04001 6.04001C6.28001 6.01001 6.53001 6 6.79001 6H13.19C16.38 6 17.98 7.60001 17.98 10.79V14.79Z"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.98 10.79C21.98 13.73 20.63 15.31 17.94 15.54C17.97 15.3 17.98 15.05 17.98 14.79V10.79C17.98 7.60001 16.38 6 13.19 6H6.79004C6.53004 6 6.28004 6.01001 6.04004 6.04001C6.27004 3.35001 7.86004 2 10.79 2H17.19C20.38 2 21.98 3.60001 21.98 6.79001V10.79Z"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.4955 13.25H13.5045"
                      stroke="#323232"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.9955 13.25H10.0045"
                      stroke="#323232"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.4955 13.25H6.5045"
                      stroke="#323232"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </Badge>
              </IconButton>
            )}
            {isLoggedIn && <NotificationOpt />}
            {isLoggedIn && (
              <Box
                sx={{
                  flexGrow: 0,
                  ml: 2,
                  mr: 5,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Tooltip title={userProfile?.name || displayName}>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    {/* <Avatar
                  alt={displayName}
                  src={pic}
                  sx={{ width: "40px", height: "40px" }}
                /> */}

                    <Avatar
                      alt={displayName}
                      {...AvatarProps(
                        [userProfile?.image_url, pic],
                        userProfile?.name || displayName,
                        "#eee",
                        { width: "40px", height: "40px" }
                      )}
                    />
                  </IconButton>
                </Tooltip>

                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                  PaperProps={{
                    sx: {
                      borderRadius: "10px",
                    },
                  }}
                >
                  <MenuOptions
                    displayName={userProfile?.name || displayName}
                    pic={userProfile?.image_url || pic}
                    email={userProfile?.email || email}
                    isLoggedIn={isLoggedIn}
                    onClose={handleCloseUserMenu}
                    {...props}
                  />
                </Menu>
              </Box>
            )}
          </Box>
        </Fragment>
      )}
      {/* ------------- End Of Auth Buttons ------------------- */}
    </Box>
  );
};

export default NavLinks;
